import React from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Stack,
  Tooltip,
  IconButton
} from "@mui/material";
import { ColorLens } from "@mui/icons-material";

const PlecaStyleForm = React.memo(function PlecaStyleForm({
  attributeId,
  label,
  values,
  onChange,
  onOpenColorPicker
}) {
  const handleChange = (field, value) => {
    onChange(attributeId, { ...values, [field]: value });
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1" fontWeight="bold">
          {label}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={values.show !== false}
              onChange={(e) => handleChange("show", e.target.checked)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#1976d2",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  bgcolor: "#1976d2",
                },
              }}
            />
          }
          label={values.show !== false ? "Visible" : "Oculto"}
        />
      </Box>

      {values.show !== false && (
        <Stack spacing={2} sx={{ pl: 2, borderLeft: "2px solid #f0f0f0" }}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body2" color="text.secondary">
              Cambiar color de fondo
            </Typography>
            <Tooltip title="Seleccionar color">
              <IconButton
                size="small"
                onClick={() => onOpenColorPicker(attributeId, values.color)}
                sx={{
                  bgcolor: values.color || "#000000",
                  borderRadius: "50%",
                  border: "1px solid #d1d5db",
                  width: 32,
                  height: 32,
                }}
              >
                <ColorLens sx={{ fontSize: 16, color: "white" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      )}
    </Box>
  );
});

export default PlecaStyleForm;
